var map = {
	"./grains_0.csv": 728,
	"./grains_1.csv": 729,
	"./grains_2.csv": 730,
	"./grains_3.csv": 731,
	"./grains_4.csv": 732,
	"./grains_5.csv": 733,
	"./grains_item_list.csv": 734
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 727;


//////////////////
// WEBPACK FOOTER
// ./src/data/grains ^\.\/.*\.csv$
// module id = 727
// module chunks = 0